module.exports = __webpack_public_path__ + "img/lobby.ea57c009.svg";